<template>
  <div
    v-if="hasPermission(userPermissions['ADD_RESPONSIBLE'])"
    class="wrapper-confirm-responsible modal-card"
  >
    <b-loading :isFullPage="false" :active="isLoading" />
    <header class="modal-card-head">
      <p class="modal-card-title is-size-5 has-text-centered">
        {{ General.WARNING }}
      </p>
      <div class="close-button cursor-pointer" @click.stop="$emit('close')">
        <b-icon icon="close" />
      </div>
    </header>
    <div class="modal-content-container">
      <section class="spacing-py-10 px-20">
        <div class="spacing-mb-10">
          <p class="has-text-weight-semibold has-text-color-7 mb-10">
            <span v-if="isBatch">
              {{ General.MESSAGES.CONFIRM_RESPONSIBLE_PROCESSES }}
            </span>
            <span v-else>
              {{ General.MESSAGES.CONFIRM_RESPONSIBLE_PROCESS }}
            </span>
          </p>

          <div class="process-table">
            <b-table :data="processList">
              <b-table-column v-slot="props" :label="General.NUP">
                <span class="has-text-color-7">
                  {{ applyMaskNUP(props.row.nup) }}
                </span>
              </b-table-column>
              <b-table-column v-slot="props" :label="General.SUBJECT">
                <span class="has-text-color-7">
                  {{ props.row.subject_name }}
                </span>
              </b-table-column>
              <b-table-column v-slot="props" :label="General.RESPONSIBLE">
                <span class="has-text-color-7">
                  {{ props.row.user_responsible_name }} <br />
                  {{ getCapacityInfo(props.row) }}
                </span>
              </b-table-column>
            </b-table>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot is-justify-content-flex-end">
        <b-button
          :type="isContrast ? 'is-white' : 'is-primary'"
          @click="confirmAction()"
        >
          {{ General.YES.toUpperCase() }}
        </b-button>
        <b-button
          :type="isContrast ? 'is-white' : 'is-warning'"
          outlined
          @click="close()"
        >
          {{ General.NO.toUpperCase() }}
        </b-button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { App, General } from "../../utils/constants";
import { USER_PERMISSIONS as userPermissions } from "@/utils/enumerate";
import { NUP, applyMask } from "@/utils/protocols";

export default {
  name: "ModalConfirmResponsible",

  props: {
    isBatch: {
      type: Boolean,
      default: false
    },
    processList: {
      type: Array,
      default: () => []
    },
    onApply: {
      type: Function,
      default: () => null
    }
  },

  data() {
    return {
      App,
      General,
      isLoading: false,
      selectedUser: null,
      userPermissions
    };
  },

  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
      isContrast: "isContrast"
    })
  },

  methods: {
    close() {
      this.$parent.close();
    },

    async confirmAction() {
      this.isLoading = true;
      await this.onApply();
      this.isLoading = false;
      this.close();
    },

    applyMaskNUP(value) {
      return applyMask(NUP, value);
    },

    getCapacityInfo(row) {
      const capacity = row.capacity || row.capacity_object || row.origin;
      return `${capacity.entity.abbreviation}/${
        capacity.abbreviation.includes("/")
          ? capacity.abbreviation.split("/")[1]
          : capacity.abbreviation
      }`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  background-color: $color-1;
  display: flex;
  max-height: 75vh;
  min-width: 800px;

  @media screen and (max-width: $tablet) {
    min-width: auto;
  }
}

.modal-content-container {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;

  .process-table {
    max-height: 250px;
    overflow-y: auto;
  }
}

.card-body {
  display: flex;
  align-content: flex-start;
  flex-direction: column;
  flex: 1;
}

.custom-self-align-end {
  align-self: flex-end;
}
</style>

<style lang="scss">
.wrapper-confirm-responsible {
  table tbody tr:hover {
    background-color: transparent !important;
  }
}
</style>
